export default "__VITE_ASSET__B5M2FK$q__"